import {
  Edit as EditIcon,
  CheckCircle as CheckIcon,
  Payment as PaymentIcon,
  LocalShipping as ShippingIcon,
  Cancel as CancelIcon,
  Receipt as ReceiptIcon,
  DoneAll as DoneAllIcon,
} from '@mui/icons-material';

// Configuración de estados para órdenes de venta
export const SALES_ORDER_STATUS_CONFIG = {
  DRAFT: { color: 'default' as const, label: 'Borrador', icon: EditIcon },
  CONFIRMED: { color: 'info' as const, label: 'Confirmada', icon: CheckIcon },
  PARTIAL_PAID: { color: 'warning' as const, label: 'Pago Parcial', icon: PaymentIcon },
  PAID: { color: 'success' as const, label: 'Pagada', icon: CheckIcon },
  DELIVERED: { color: 'success' as const, label: 'Entregada', icon: ShippingIcon },
  CANCELLED: { color: 'error' as const, label: 'Cancelada', icon: CancelIcon },
  REFUNDED: { color: 'error' as const, label: 'Reembolsada', icon: ReceiptIcon },
} as const;

// Configuración de estados de logística para ventas mixtas (independiente del pago).
// Etiquetas alineadas con utils/sales/saleFulfillmentPresentation (fuente única).
// NOT_REQUIRED se omite intencionalmente: no debe renderizarse ningún chip secundario.
export const SALE_FULFILLMENT_STATUS_CONFIG = {
  PENDING: { color: 'warning' as const, label: 'Envío pendiente', icon: ShippingIcon },
  COMPLETED: { color: 'success' as const, label: 'Envío completado', icon: DoneAllIcon },
  FAILED: { color: 'error' as const, label: 'Rechazada', icon: CancelIcon },
  CANCELLED: { color: 'error' as const, label: 'Envío cancelado', icon: CancelIcon },
} as const;

// Opciones de estado para filtros
export const SALES_ORDER_STATUS_OPTIONS = [
  { value: '', label: 'Todos los estados' },
  { value: 'DRAFT', label: 'Borrador' },
  { value: 'CONFIRMED', label: 'Confirmada' },
  { value: 'PARTIAL_PAID', label: 'Pago Parcial' },
  { value: 'PAID', label: 'Pagada' },
  { value: 'DELIVERED', label: 'Entregada' },
  { value: 'CANCELLED', label: 'Cancelada' },
  { value: 'REFUNDED', label: 'Reembolsada' },
] as const;
